import React, { Suspense, useMemo } from 'react'
import { RFI_TYPE_LOCATION } from '../../../../common/commonConstants'
import { getObjectDataNode } from '../../../../common'
import { rfi2FinishedGoodSectionMapper } from '../../../../globalComponents/RfiConstants'
import { DynamicSectionBuilder } from '../../../../globalComponents/Builders'
import {
  BeautyFormulationCapabilities,
  BeautyPackagingCapabilities,
} from '../../../../globalComponents/RfiCommons'
import {
  FactoryCapabilities,
  EmployeeInformation,
} from '../../../../globalComponents/Rfi2'
import { ToastAlertProvider } from '@design-systems/canvas-ui'

const PackagingEquipmentLazy = React.lazy(
  () =>
    import('../../../../globalComponents/Rfi2/packaging/PackagingEquipment'),
)

const Rfi3SectionContent = ({
  rfi3Template,
  rfi3Data,
  rfiMasterData,
  isReadonly,
  activeTab,
  activeRFI3Section,
  errorCache,
  saveRfi3Payload,
  getTabIdByName,
}) => {
  const tabs = rfi3Template?.dynamic_sections?.tabs || []
  const currentTab = tabs[activeTab.index]

  const sections = currentTab?.sections || []

  const currentSections = useMemo(
    () =>
      sections.filter(
        (eachSection) => eachSection.section_name === activeRFI3Section.name,
      ),
    [sections, activeRFI3Section.name],
  )

  if (!rfi3Template || !rfi3Data || !currentSections.length) return null

  return currentSections.map((eachSection, sectionIndex) => {
    const sectionRfiObject = getObjectDataNode(
      rfi3Data,
      rfi2FinishedGoodSectionMapper[eachSection.uid],
    )

    const tabId = getTabIdByName(activeTab.name)
    const sectionPath = tabId ? `${tabId}.${eachSection.uid}` : eachSection.uid

    const commonProps = {
      isRfi3: true,
      isReadonly: true,
      isRfi3Readonly: isReadonly,
      sectionPath,
      errorCache,
      sectionTemplate: eachSection,
      sectionData: sectionRfiObject,
      rfiMasterData,
      rfiType: RFI_TYPE_LOCATION,
      saveRfiPayload: saveRfi3Payload,
      supplierId: rfi3Data?.supplier_id,
      locationId: rfi3Data?.location_id,
      manufacturingTypeId: rfi3Data?.manufacturing_type_id,
    }

    switch (eachSection.uid.toUpperCase()) {
      case 'FACTORY_CAPABILITIES':
        return (
          <ToastAlertProvider location="top" key={`section-${sectionIndex}`}>
            <FactoryCapabilities {...commonProps} />
          </ToastAlertProvider>
        )

      case 'BEAUTY_FORMULATION_CAPABILITIES':
        return (
          <BeautyFormulationCapabilities
            key={`section-${sectionIndex}`}
            {...commonProps}
          />
        )

      case 'BEAUTY_PACKAGING_CAPABILITIES':
        return (
          <BeautyPackagingCapabilities
            key={`section-${sectionIndex}`}
            {...commonProps}
          />
        )

      case 'EMPLOYEE_INFORMATION':
        return (
          <EmployeeInformation
            key={`section-${sectionIndex}`}
            {...commonProps}
          />
        )

      case 'PACKAGING_EQUIPMENT':
        return (
          <Suspense key={`section-${sectionIndex}`} fallback={null}>
            <PackagingEquipmentLazy {...commonProps} />
          </Suspense>
        )

      default:
        return (
          <DynamicSectionBuilder
            key={`section-${sectionIndex}`}
            rfiType={RFI_TYPE_LOCATION}
            isRfi3
            isRfi3Readonly={isReadonly}
            sectionPath={sectionPath}
            errorCache={errorCache}
            sectionTemplate={eachSection}
            sectionData={sectionRfiObject}
            rfiMasterData={rfiMasterData}
            saveRfiPayload={saveRfi3Payload}
            supplierId={rfi3Data?.supplier_id}
            locationId={rfi3Data?.location_id}
            manufacturingTypeId={rfi3Data?.manufacturing_type_id}
          />
        )
    }
  })
}

export default React.memo(Rfi3SectionContent)
